import '../features/header';
import '../features/burger';
import '../features/counter';
import '../features/slider';
import '../features/bestGifts';
